import { render, staticRenderFns } from "./BookAdditionalChargeMain.vue?vue&type=template&id=770c016e&scoped=true&"
import script from "./BookAdditionalChargeMain.vue?vue&type=script&lang=js&"
export * from "./BookAdditionalChargeMain.vue?vue&type=script&lang=js&"
import style0 from "./BookAdditionalChargeMain.vue?vue&type=style&index=0&id=770c016e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c016e",
  null
  
)

export default component.exports